import { Tag } from 'antd'
import { useIndexPrice } from 'app/hooks/trade/indexprice'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import CRenderEmpty from '../CRenderEmpty'

const MarkPrice = ({ data }) => {
	let { getPrice } = useIndexPrice(data?.exchange_pairs_id)

	return (
		<Text
			style={{
				justifyContent: 'flex-end',
				alignItems: 'center',
			}}>
			<span
				style={{
					backgroundColor: '#efefef',
					padding: 1,
					borderRadius: 2,
					fontSize: 13,
				}}>
				<span style={{ fontSize: 5 }}>현재</span>{' '}
				{BigNumber(getPrice(data?.exchange_pairs_id)).toFormat(
					data?.dp || 3
				)}
			</span>

			<CRenderEmpty id={data?.exchange_pairs_id} />
		</Text>
	)
}

export default MarkPrice
